/* ASK A VET™ — DKA vs HHS Crisis Calculator | Shopify redesign */
(() => {
  'use strict';
  const ELEMENT_NAME = 's-dka-hhs-calculator';
  if (customElements.get(ELEMENT_NAME)) return;

  class DkaHhsCalculator extends HTMLElement {
    connectedCallback() {
      if (this.__dkhInitialised) return;
      this.__dkhInitialised = true;
      this.initCalculator();
    }

    initCalculator() {

'use strict';
const S = {system:'metric', species:'dog', dmEvidence:'unknown', gluUnit:'mmol', ureaUnit:'mmol', weightUnit:'kg', ketSource:'blood', urineKet:'unknown', sglt2:'unknown', hours:24, insProtocol:'vri'};
const dirty = {targetNa:false, insDose:false};
const accState = {'acc-flow':true, 'acc-ins':true}; // safety sections start open and persist across re-renders
let lastD = null; // most recent computed data, for copy/print
const LB_PER_KG = 2.20462;
const GLU_MGDL_PER_MMOL = 18.0182;
const ROOT = this;
const $ = id => ROOT.querySelector(`[id="${id}"]`);
const num = id => { const v = parseFloat($(id).value); return isFinite(v) ? v : null; };

// unit helpers
const gluToMmol = v => S.gluUnit==='mmol' ? v : v/GLU_MGDL_PER_MMOL;
const gluToMgdl = v => S.gluUnit==='mmol' ? v*GLU_MGDL_PER_MMOL : v;
const ureaToMmol = v => S.ureaUnit==='mmol' ? v : v/2.8; // BUN mg/dL -> osmolality-equivalent urea mmol/L
const bwToKg = v => S.weightUnit==='kg' ? v : v/LB_PER_KG;    // internal calcs always use kg
// display-unit labels driven by the master system toggle
const naUnitLabel  = () => S.system==='imperial' ? 'mEq/L' : 'mmol/L';
const osmUnitLabel = () => 'mOsm/kg';
const fmt = (v,d=1)=> v==null||!isFinite(v) ? '—' : (Math.round(v*10**d)/10**d).toLocaleString(undefined,{minimumFractionDigits:d,maximumFractionDigits:d});
const fmt0 = v => v==null||!isFinite(v) ? '—' : Math.round(v).toLocaleString();

// segmented / toggle wiring
function wireSeg(id, key, attr, cb){
  $(id).querySelectorAll('button').forEach(b=>b.onclick=()=>{
    const previous=S[key];
    $(id).querySelectorAll('button').forEach(x=>x.classList.remove('active'));
    b.classList.add('active'); S[key]=b.getAttribute(attr); syncPressed(id); if(cb)cb(previous,S[key]); calc();
  });
}
wireSeg('species','species','data-sp',setTargetDefault);

function syncPressed(groupId){
  $(groupId).querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed', b.classList.contains('active') ? 'true' : 'false'));
}
['system','species','dmEvidence','wtUnit','gluUnit','ureaUnit','ketSrc','urineLevel','sglt2','hours','insProtocol'].forEach(syncPressed);
wireSeg('dmEvidence','dmEvidence','data-v');

// ketone source toggle — swap between blood BHB input and urine dipstick levels
$('ketSrc').querySelectorAll('button').forEach(b=>b.onclick=()=>{
  $('ketSrc').querySelectorAll('button').forEach(x=>x.classList.remove('active'));
  b.classList.add('active'); S.ketSource=b.getAttribute('data-src');
  syncPressed('ketSrc');
  $('bloodKet').style.display = S.ketSource==='blood' ? '' : 'none';
  $('urineKet').style.display = S.ketSource==='urine' ? '' : 'none';
  calc();
});
// urine dipstick level
$('urineLevel').querySelectorAll('button').forEach(b=>b.onclick=()=>{
  $('urineLevel').querySelectorAll('button').forEach(x=>x.classList.remove('active'));
  b.classList.add('active'); S.urineKet=b.getAttribute('data-u'); syncPressed('urineLevel'); calc();
});
wireSeg('sglt2','sglt2','data-v');
// insulin protocol toggle (VRI sliding / FRI fixed / IM)
const insProtoNotes = {
  vri:'Variable-rate CRI: change the insulin pump rate with glucose; add dextrose as it falls.',
  fri:'Fixed-rate CRI: insulin runs at one constant rate; manage glucose by scaling dextrose in a separate line.',
  im:'Intermittent IM: hourly Actrapid injections when no CRI pump is available. No bag needed.'
};
$('insProtocol').querySelectorAll('button').forEach(b=>b.onclick=()=>{
  $('insProtocol').querySelectorAll('button').forEach(x=>x.classList.remove('active'));
  b.classList.add('active'); S.insProtocol=b.getAttribute('data-p');
  syncPressed('insProtocol');
  $('bagSetup').style.display = S.insProtocol==='im' ? 'none' : '';
  $('insProtocolNote').textContent = insProtoNotes[S.insProtocol];
  calc();
});
$('insProtocolNote').textContent = insProtoNotes.vri;

// convert a numeric field's value in place (keeps the same patient when flipping units)
function convertField(id, mult){ const v=num(id); if(v!=null) $(id).value = Math.round(v*mult*100000000)/100000000; }

// glucose unit toggle — converts the entered value
$('gluUnit').querySelectorAll('button').forEach(b=>b.onclick=()=>{
  const to=b.getAttribute('data-u'); if(to===S.gluUnit) return;
  convertField('glu', to==='mgdl'?GLU_MGDL_PER_MMOL:1/GLU_MGDL_PER_MMOL);
  S.gluUnit=to; setToggleActive('gluUnit',to); updateLabels(); calc();
});
// urea/BUN unit toggle — converts the entered value (urea mmol/L <-> BUN mg/dL)
$('ureaUnit').querySelectorAll('button').forEach(b=>b.onclick=()=>{
  const to=b.getAttribute('data-u'); if(to===S.ureaUnit) return;
  convertField('urea', to==='mgdl'?2.8:1/2.8);
  S.ureaUnit=to; setToggleActive('ureaUnit',to); updateLabels(); calc();
});
$('hours').querySelectorAll('button').forEach(b=>b.onclick=()=>{
  $('hours').querySelectorAll('button').forEach(x=>x.classList.remove('active'));
  b.classList.add('active'); S.hours=parseInt(b.getAttribute('data-h')); syncPressed('hours'); calc();
});
['bw','dehy','glu','na','k','cl','urea','measOsm','ph','hco3','bhb','bagVol'].forEach(id=>$(id).addEventListener('input',calc));
$('targetNa').addEventListener('input',()=>{dirty.targetNa=true;calc();});
$('insDose').addEventListener('input',()=>{dirty.insDose=true;calc();});

// visually mark the active button of a unit-toggle group by its data-u value
function setToggleActive(groupId, val){
  $(groupId).querySelectorAll('button').forEach(b=>b.classList.toggle('active', b.getAttribute('data-u')===val));
  syncPressed(groupId);
}

// convert the weight field so it represents the SAME animal after a unit switch
function convertWeightField(from, to){
  const v = num('bw');
  if(v==null || from===to) return;
  const kg = from==='kg' ? v : v/LB_PER_KG;
  $('bw').value = to==='kg' ? Math.round(kg*1000)/1000 : Math.round(kg*LB_PER_KG*1000)/1000;
}

// weight-only unit toggle
$('wtUnit').querySelectorAll('button').forEach(b=>b.onclick=()=>{
  const to = b.getAttribute('data-u');
  if(to===S.weightUnit) return;
  convertWeightField(S.weightUnit, to);
  S.weightUnit = to; setToggleActive('wtUnit', to); updateLabels(); calc();
});

// master metric/imperial toggle — drives weight + glucose + BUN together
$('system').querySelectorAll('button').forEach(b=>b.onclick=()=>{
  const sys = b.getAttribute('data-sys');
  $('system').querySelectorAll('button').forEach(x=>x.classList.remove('active'));
  b.classList.add('active'); S.system = sys;
  syncPressed('system');
  const wt = sys==='imperial' ? 'lb' : 'kg';
  if(wt!==S.weightUnit){ convertWeightField(S.weightUnit, wt); S.weightUnit = wt; }
  const gu = sys==='imperial' ? 'mgdl' : 'mmol';
  if(gu!==S.gluUnit){ convertField('glu', gu==='mgdl'?GLU_MGDL_PER_MMOL:1/GLU_MGDL_PER_MMOL); S.gluUnit = gu; }
  if(gu!==S.ureaUnit){ convertField('urea', gu==='mgdl'?2.8:1/2.8); S.ureaUnit = gu; }
  setToggleActive('wtUnit', S.weightUnit);
  setToggleActive('gluUnit', S.gluUnit);
  setToggleActive('ureaUnit', S.ureaUnit);
  updateLabels(); calc();
});

// keep input labels/placeholders in sync with the chosen units
function updateLabels(){
  $('bwLabel').textContent = 'Body weight (' + S.weightUnit + ')';
  $('bw').placeholder = S.weightUnit==='kg' ? 'e.g. 22' : 'e.g. 48';
  $('bw').max = S.weightUnit==='kg' ? '500' : '1102';
  $('naLabel').textContent = 'Sodium — Na⁺ (' + naUnitLabel() + ')';
  $('kLabel').textContent  = 'Potassium — K⁺ (' + naUnitLabel() + ')';
  $('clLabel').textContent = 'Chloride — Cl⁻ (' + naUnitLabel() + ')';
  $('targetNaLabel').textContent = 'Target sodium (' + naUnitLabel() + ')';
  $('glu').placeholder = S.gluUnit==='mmol' ? 'e.g. 32' : 'e.g. 576';
  $('glu').max = S.gluUnit==='mmol' ? '222' : '4000';
  $('ureaLabel').textContent = S.ureaUnit==='mmol' ? 'Urea (mmol/L)' : 'BUN (mg/dL)';
  $('urea').placeholder = S.ureaUnit==='mmol' ? 'optional — e.g. 15' : 'optional — e.g. 42';
  $('urea').max = S.ureaUnit==='mmol' ? '500' : '1400';
  $('measOsmLabel').textContent = 'Measured serum osmolality (' + osmUnitLabel() + ')';
  $('targetNote').textContent = S.species==='dog'
    ? 'Default 145 '+naUnitLabel()+' (canine mid-normal). Editable.'
    : 'Default 151 '+naUnitLabel()+' (feline mid-normal). Editable.';
  $('bhbNote').innerHTML = S.species==='dog'
    ? 'A study-derived canine DKA screening cut-off is <b>&gt;3.8 mmol/L</b> (70% sensitivity, 92% specificity); <b>0.5–3.8</b> is an intermediate range. No single result excludes DKA—interpret with acid–base status and trend.'
    : 'A feline screening point is <b>&gt;2.4 mmol/L</b>; <b>1.0–2.4</b> in an unwell cat is concerning. Meter variation precludes a universal exclusion cut-off, and a ketone value alone does not diagnose DKA.';
}

// Re-label the urea field WITHOUT converting the number. Used by the unit-trap guard: if the
// figure typed in was always a BUN, the value is right and only the unit was wrong — running it
// through the normal toggle would convert it a second time and make it worse.
function reinterpretUrea(to){
  if(to===S.ureaUnit) return;
  S.ureaUnit = to;
  setToggleActive('ureaUnit', to);
  updateLabels();
  calc();
}

function setTargetDefault(previousSpecies=null, newSpecies=S.species){
  const force=previousSpecies==null;
  const t = newSpecies==='dog' ? 145 : 151;
  if(force || !dirty.targetNa) $('targetNa').value = t;
  const u = naUnitLabel();
  $('targetNote').textContent = newSpecies==='dog'
    ? 'Default 145 '+u+' (canine mid-normal). Editable.'
    : 'Default 151 '+u+' (feline mid-normal). Editable.';
  // insulin dose default (standard DiBartola/Macintire recipe)
  if(force || !dirty.insDose) $('insDose').value = newSpecies==='dog' ? 2.2 : 1.1;
  $('insDoseNote').textContent = newSpecies==='dog'
    ? 'Standard 2.2 U/kg (dog). Total drawn up = 2.2 × body weight.'
    : 'Standard 1.1 U/kg (cat). Total drawn up = 1.1 × body weight.';
  $('sglt2Wrap').style.display = newSpecies==='cat' ? '' : 'none';
  updateLabels();
}
setTargetDefault();
updateLabels();

function calc(){
  const invalidInputs=[];
  const read = (id,min,max,label)=>{
    const el=$(id), raw=String(el.value).trim();
    el.classList.remove('invalid'); el.removeAttribute('aria-invalid'); el.removeAttribute('title');
    if(raw==='') return null;
    const v=Number(raw);
    if(!Number.isFinite(v) || v<min || v>max){
      el.classList.add('invalid'); el.setAttribute('aria-invalid','true');
      el.title=`Enter ${label} between ${min} and ${max}.`;
      invalidInputs.push(`${label} must be between ${min} and ${max}.`);
      return null;
    }
    return v;
  };

  const bwRaw = read('bw',0.05,S.weightUnit==='kg'?500:1102,'body weight');
  const bw = bwRaw!=null ? bwToKg(bwRaw) : null;
  const dehy = read('dehy',0,20,'estimated dehydration');
  const gluRaw = read('glu',0,S.gluUnit==='mmol'?222:4000,'blood glucose');
  const gluM = gluRaw!=null ? gluToMmol(gluRaw) : null;
  const gluMg = gluRaw!=null ? gluToMgdl(gluRaw) : null;
  const na = read('na',80,220,'sodium');
  const k = read('k',1,10,'potassium');
  const cl = read('cl',40,220,'chloride');
  const ureaRaw = read('urea',0,S.ureaUnit==='mmol'?500:1400,S.ureaUnit==='mmol'?'urea':'BUN');
  const ureaM = ureaRaw!=null ? ureaToMmol(ureaRaw) : null;
  const measuredOsm = read('measOsm',200,600,'measured osmolality');
  const ph = read('ph',6.5,7.8,'venous pH');
  const hco3 = read('hco3',0,60,'bicarbonate');
  const bhb = S.ketSource==='blood' ? read('bhb',0,30,'blood BHB') : null;
  if(S.ketSource!=='blood'){
    $('bhb').classList.remove('invalid'); $('bhb').removeAttribute('aria-invalid'); $('bhb').removeAttribute('title');
  }
  const targetNa = read('targetNa',120,180,'target sodium');

  // Ketone criteria. Blood thresholds are screening cut-offs, not stand-alone diagnoses.
  const bhbDkaCut = S.species==='dog' ? 3.8 : 2.4;
  const bhbConcernCut = S.species==='dog' ? 0.5 : 1.0;
  let dkaKetosis=null, hhsMinimalKetones=null, anyKetosis=null, ketVal='—', ketDesc='not entered';
  if(S.ketSource==='urine'){
    const order = {unknown:null,neg:0,trace:1,small:2,mod:3,large:4};
    const sym   = {unknown:'—',neg:'neg',trace:'trace',small:'+',mod:'++',large:'+++'};
    const name  = {unknown:'Not entered',neg:'Negative',trace:'Trace',small:'Small (+)',mod:'Moderate (++)',large:'Large (+++)'};
    const idx=order[S.urineKet];
    if(idx!=null){
      anyKetosis=idx>=1;
      dkaKetosis=idx>=1;
      hhsMinimalKetones=idx<=1;
    }
    ketVal=sym[S.urineKet];
    ketDesc='Urine dipstick '+name[S.urineKet];
  } else if(bhb!=null){
    anyKetosis=bhb>=bhbConcernCut;
    dkaKetosis=bhb>bhbDkaCut;
    hhsMinimalKetones=bhb<3.0;
    ketVal=fmt(bhb);
    ketDesc=`Blood BHB ${fmt(bhb)} mmol/L`;
  } else {
    ketDesc='Blood BHB (not entered)';
  }

  // Calculated tonicity excludes urea; total calculated osmolality includes urea but not K.
  let effOsm=null,totOsm=null,totOsmExclUrea=false;
  if(na!=null && gluM!=null){
    effOsm=2*na+gluM;
    totOsm=effOsm+(ureaM!=null?ureaM:0);
    totOsmExclUrea=ureaM==null;
  }

  // Corrected sodium: clamp below 100 mg/dL so hypoglycaemia never creates a negative correction.
  let naKatz=null,naHillier=null;
  if(na!=null && gluMg!=null){
    const glucoseExcess=Math.max(0,(gluMg-100)/100);
    naKatz=na+1.6*glucoseExcess;
    naHillier=na+2.4*glucoseExcess;
  }
  const naCorr=naKatz; // 1.6 is validated in hyperglycaemic dogs; feline use remains extrapolated.

  // Acid-base pattern. Definite DKA requires both acidemia and reduced bicarbonate.
  const pHLow=ph!=null ? ph<7.35 : null;
  const hco3Low=hco3!=null ? hco3<15 : null;
  let acidStatus='unknown';
  if(pHLow!=null && hco3Low!=null){
    acidStatus=(pHLow&&hco3Low)?'met':(!pHLow&&!hco3Low?'not':'conflict');
  } else if(pHLow===true || hco3Low===true){
    acidStatus='partial';
  } else if(pHLow===false || hco3Low===false){
    acidStatus='partial-normal';
  }
  const dkaAcidosis=acidStatus==='met';
  const noHhsAcidosis=ph!=null && hco3!=null && ph>=7.35 && hco3>=15;

  // Optional anion gap using the K-inclusive formula and species-specific reference ceiling.
  let anionGap=null, anionGapHigh=null;
  const agUpper=S.species==='dog'?24:27;
  if(na!=null && k!=null && cl!=null && hco3!=null){
    anionGap=(na+k)-(cl+hco3);
    anionGapHigh=anionGap>agUpper;
  }

  // Tiny tolerances prevent unit-toggle floating-point noise from flipping strict clinical cut-offs.
  const glucoseBoundaryTolerance=0.01; // mg/dL — far below any analyser's reporting precision
  const osmBoundaryTolerance=0.001;   // mOsm/kg
  const hyper=gluMg==null ? null : gluMg>250+glucoseBoundaryTolerance;
  const severeHyper=gluMg==null ? null : gluMg>600+glucoseBoundaryTolerance;
  const euglycaemicRange=gluMg==null ? null : gluMg<=250+glucoseBoundaryTolerance;
  const hyperosm=effOsm==null ? null : effOsm>320+osmBoundaryTolerance;
  const severeOsm=effOsm==null ? null : effOsm>=330;
  const dmSupported=S.dmEvidence==='yes';
  const dmUnknown=S.dmEvidence==='unknown';

  const mixedFull=severeHyper && hyperosm && dkaKetosis===true && dkaAcidosis;
  const hhsFull=severeHyper && hyperosm && hhsMinimalKetones===true && dkaKetosis!==true && noHhsAcidosis;
  const dkaFull=hyper && dkaKetosis===true && dkaAcidosis;
  const edkaFull=euglycaemicRange && dkaKetosis===true && dkaAcidosis;
  const confirmedCrisis=Boolean(mixedFull||hhsFull||dkaFull||edkaFull);

  let cls='none', label='Enter core values', tag='Classification incomplete', confidence='Insufficient data';
  let desc='Enter glucose, ketone status and both venous pH and bicarbonate. Sodium is additionally required to assess HHS or mixed DKA–HHS.';
  if(mixedFull){
    cls='mixed'; tag='Overlapping crisis pattern'; label='Mixed DKA–HHS'; confidence=dmSupported?'Criteria met':'Biochemical pattern';
    desc='The full DKA pattern is present together with severe hyperglycaemia and effective osmolality above 320 mOsm/kg. Treat ketogenesis/acidosis while applying the slower HHS tonicity safeguards.';
  } else if(hhsFull){
    cls='hhs'; tag='Hyperosmolar crisis pattern'; label='HHS'; confidence=dmSupported?'Criteria met':'Biochemical pattern';
    desc='Glucose is above 600 mg/dL, effective osmolality is above 320 mOsm/kg, ketones are absent or mild, and significant acidosis is not present.';
  } else if(dkaFull){
    cls='dka'; confidence=dmSupported?'Criteria met':'Biochemical pattern';
    if(hyperosm){
      tag='Ketoacidotic crisis with severe hypertonicity'; label='DKA with severe hypertonicity';
      desc='The full DKA pattern is present and effective osmolality is above 320 mOsm/kg. Glucose does not meet the full HHS threshold, but the hypertonicity still warrants slower HHS-style correction safeguards and neurological monitoring.';
    } else {
      tag='Ketoacidotic crisis pattern'; label='DKA';
      desc=severeHyper
        ? 'Hyperglycaemia, DKA-range ketones, acidemia and reduced bicarbonate are present. Sodium is not required to identify DKA, but is needed to assess HHS overlap at this glucose concentration.'
        : 'Hyperglycaemia, DKA-range ketones, acidemia and reduced bicarbonate are present.';
    }
  } else if(edkaFull){
    cls='edka'; tag='Ketoacidotic pattern with glucose ≤250 mg/dL'; label='Possible euglycaemic DKA';
    confidence=(S.species==='cat'&&S.sglt2==='yes')||dmSupported?'High concern':'Requires diabetes context';
    desc=(S.species==='cat'&&S.sglt2==='yes')
      ? 'Ketosis and metabolic acidosis are present despite relative euglycaemia in a cat exposed to an SGLT2 inhibitor. Stop the SGLT2 inhibitor and manage urgently as suspected eDKA.'
      : 'Ketosis and metabolic acidosis are present without classic hyperglycaemia. Confirm diabetes/SGLT2 exposure and exclude other causes of high-anion-gap ketoacidosis.';
  } else if(S.species==='cat' && S.sglt2==='yes' && euglycaemicRange && dkaAcidosis && dkaKetosis!==true){
    cls='edka'; tag='SGLT2-exposed cat with euglycaemic metabolic acidosis'; label='eDKA not excluded — measure blood BHB now'; confidence='Urgent confirmation required';
    desc=S.ketSource==='urine'
      ? 'Urine dipsticks do not measure BHB and can be negative early in eDKA. Stop the SGLT2 inhibitor, obtain a current blood BHB result and serial acid–base/electrolyte measurements, and investigate other high-anion-gap causes.'
      : 'SGLT2 exposure plus euglycaemic metabolic acidosis is highly concerning even without a diagnostic BHB result. Stop the SGLT2 inhibitor, repeat blood BHB promptly and investigate other high-anion-gap causes.';
  } else if(severeHyper && hyperosm && dkaAcidosis && dkaKetosis===false){
    cls='hhs'; tag='Hyperosmolar crisis with acidosis'; label='Not mixed DKA–HHS on the entered ketone result'; confidence='Investigate the acidosis';
    if(anyKetosis===true){
      label='Hyperosmolar crisis with acidosis — DKA component not excluded'; confidence='BHB screening band';
      desc='Severe hyperglycaemia and hyperosmolality are present with acidemia/reduced bicarbonate. BHB is below the study-derived DKA screening cut-off but within a concerning intermediate range; repeat BHB and investigate lactate, uraemia, toxins and mixed acid–base disorders.';
    } else {
      desc='Severe hyperglycaemia and hyperosmolality are present with acidemia/reduced bicarbonate, but DKA-range ketosis is not. Consider lactate, uraemia, toxins and other acid–base disorders; repeat BHB if clinical suspicion remains high.';
    }
  } else if(severeHyper && hyperosm && dkaKetosis===true && acidStatus==='not'){
    cls='hhs'; tag='Hyperosmolar crisis with ketosis'; label='Mixed DKA–HHS acidosis criterion not met'; confidence='Serial monitoring required';
    desc='Severe hyperglycaemia, hyperosmolality and ketosis are present, but both entered acid–base values are outside this calculator’s DKA acidosis definition. Concurrent alkalosis can still mask DKA, so interpret the anion gap and trend.';
  } else if(severeHyper && hyperosm){
    cls='hhs'; tag='Hyperosmolar crisis — subtype incomplete'; label='HHS or mixed crisis not yet resolved'; confidence='More data required';
    desc='The glucose and hyperosmolality criteria are present, but ketone and/or complete acid–base criteria do not establish pure HHS or mixed DKA–HHS.';
  } else if(hyper && dkaKetosis===true && acidStatus!=='met'){
    if(acidStatus==='not'){
      cls='none'; tag='Ketotic diabetic pattern'; label='Diabetic ketosis without DKA-range acidosis'; confidence='Serial monitoring required';
      desc='Hyperglycaemia and ketosis are present, but both pH and bicarbonate do not meet this calculator’s DKA acidosis criteria. Concurrent alkalosis can still mask ketoacidosis; interpret the anion gap and trend.';
    } else {
      cls='dka'; tag='Suspected ketoacidotic crisis'; label='Possible DKA — acid–base status incomplete';
      confidence=acidStatus==='conflict'?'Conflicting acid–base values':'Urgent confirmation required';
      desc='Hyperglycaemia and DKA-range ketones are present, but pH/bicarbonate are missing, partial or discordant. An unwell ketotic diabetic should be managed as suspected DKA while acid–base status, anion gap and serial BHB are clarified.';
    }
  } else if(hyper && dkaAcidosis && anyKetosis===true && dkaKetosis===false){
    cls='dka'; tag='Ketoacidotic pattern — BHB screening band'; label='Possible DKA; ketone result is indeterminate'; confidence='Cannot confirm or exclude';
    desc='Hyperglycaemia and metabolic acidosis are present, while BHB is concerning but below the study-derived screening cut-off. Meter and timing effects mean DKA is not excluded; repeat BHB and interpret the anion gap and clinical trajectory.';
  } else if(hyper && dkaAcidosis && dkaKetosis!==true){
    cls='dka'; tag='Hyperglycaemic metabolic acidosis';
    label=dkaKetosis==null?'Possible DKA — ketone result required':'DKA not excluded by a low ketone screen';
    confidence='Urgent differential diagnosis';
    desc=dkaKetosis==null
      ? 'Hyperglycaemia, acidemia and reduced bicarbonate are present, but ketones have not been entered. Measure blood BHB promptly and assess the anion gap, lactate, renal function, toxins and serial change.'
      : 'Hyperglycaemia, acidemia and reduced bicarbonate are present even though this ketone result is below the study-derived concern band. No single BHB measurement excludes DKA; repeat it and investigate lactate, uraemia, toxins and other metabolic-acidosis causes.';
  } else if(euglycaemicRange && dkaAcidosis && anyKetosis===true && dkaKetosis===false){
    cls='edka'; tag='Euglycaemic ketoacidotic pattern — BHB screening band'; label='Possible euglycaemic DKA; ketone result is indeterminate';
    confidence=(S.species==='cat'&&S.sglt2==='yes')?'High concern':'Cannot confirm or exclude';
    desc='Metabolic acidosis is present with a concerning intermediate BHB result despite glucose at or below 250 mg/dL. Repeat BHB and urgently assess diabetes/SGLT2 exposure and other causes of high-anion-gap ketoacidosis.';
  } else if(hyper && anyKetosis===true && dkaKetosis===false){
    cls='none'; tag='Intermediate ketone result'; label='DKA not confirmed or excluded by BHB'; confidence='Repeat and trend';
    desc='BHB is above the species concern threshold but below the study-derived DKA screening cut-off. Interpret with pH, bicarbonate, anion gap, illness severity, meter type and serial change.';
  } else if(gluM!=null && ph!=null && hco3!=null && dkaKetosis!=null && (severeHyper===false || na!=null)){
    cls='none'; tag='Criteria assessed'; label='DKA/HHS criteria not met'; confidence='On entered values';
    desc='The complete values entered do not meet this calculator’s biochemical pattern for DKA, HHS or mixed DKA–HHS. Reassess trends and the wider differential diagnosis.';
  } else if(gluM!=null){
    cls='none'; tag='Classification incomplete'; label='More data needed'; confidence='Do not rule out crisis';
    desc='A glucose result alone cannot distinguish DKA from HHS. Add ketones and both pH and bicarbonate; add sodium to calculate effective osmolality.';
  }

  const missing=[];
  if(gluM==null) missing.push('blood glucose');
  if(dkaKetosis==null) missing.push(S.ketSource==='blood'?'blood BHB':'urine ketone result');
  if(ph==null) missing.push('venous pH');
  if(hco3==null) missing.push('bicarbonate');
  if(na==null && severeHyper!==false) missing.push('sodium (needed for HHS/mixed assessment)');
  if(dmUnknown) missing.push('diabetes context (needed to call the pattern diabetic)');
  if(S.dmEvidence==='no' && ['dka','hhs','mixed','edka'].includes(cls)) missing.push('diabetes mellitus is not established; confirm it before crisis-specific insulin dosing');
  if(cls==='edka' && S.species==='cat' && S.sglt2==='yes' && S.ketSource==='urine' && dkaKetosis!==true) missing.push('blood BHB (a negative urine dipstick does not exclude eDKA)');

  // Free water deficit uses Katz-corrected Na and is only shown above target.
  let fwd=null;
  if(bw!=null && naCorr!=null && targetNa!=null){ fwd=Math.max(0,0.6*bw*((naCorr/targetNa)-1)); }

  // dehydration deficit
  let deficitL=null;
  if(bw!=null && dehy!=null){ deficitL = (dehy/100)*bw; }

  // maintenance
  let maintDay=null;
  if(bw!=null){ maintDay = (S.species==='dog'?60:50)*bw; } // mL/day
  const maintHr = maintDay!=null ? maintDay/24 : null;

  // total rate
  let totalRate=null;
  if(deficitL!=null && maintHr!=null){
    totalRate = (deficitL*1000)/S.hours + maintHr; // mL/hr, deficit over chosen hours
  }

  // safe sodium correction time (if hypernatraemic on corrected Na)
  let naGap=null, minHoursNa=null;
  if(naCorr!=null && targetNa!=null){
    naGap = naCorr - targetNa;
    if(naGap>0){ minHoursNa = naGap/0.5; } // 0.5 mmol/L/hr max
  }

  // glucose fall guidance
  // potassium sliding scale
  function kScale(kv){
    if(kv==null) return null;
    const u = S.system==='imperial' ? 'mEq' : 'mmol'; // KCl amount unit (mEq ≡ mmol for K⁺)
    // Bands per DiBartola / Merck Veterinary Manual potassium supplementation guideline
    if(kv>5.0) return {add:0, note:'Hold KCl. Recheck K⁺ in 4–6 h before supplementing.'};
    if(kv>=3.6) return {add:20, note:`Add 20 ${u} KCl per litre.`};
    if(kv>=3.1) return {add:30, note:`Add 30 ${u} KCl per litre.`};
    if(kv>=2.6) return {add:40, note:`Add 40 ${u} KCl per litre.`};
    if(kv>=2.1) return {add:60, note:`Add 60 ${u} KCl per litre.`};
    return {add:80, note:`Add 80 ${u} KCl per litre. Delay insulin until K⁺ ≥ 3.5.`};
  }
  const ks = kScale(k);
  // max fluid rate to keep KCl <= 0.5 mmol/kg/hr
  let maxKfluid=null;
  if(ks && ks.add>0 && bw!=null){ maxKfluid = (0.5*bw)/(ks.add/1000); } // mL/hr
  const kRateExceeded = (maxKfluid!=null && totalRate!=null && totalRate>maxKfluid);

  // insulin CRI
  const defaultDose = S.species==='dog' ? 2.2 : 1.1;
  const insDose=S.insProtocol==='im'?null:read('insDose',0.1,5,'insulin bag dose');
  const bagVol=S.insProtocol==='im'?null:read('bagVol',100,1000,'insulin carrier volume');
  if(S.insProtocol==='im'){
    ['insDose','bagVol'].forEach(id=>{$(id).classList.remove('invalid');$(id).removeAttribute('aria-invalid');$(id).removeAttribute('title');});
  }
  let insUnits=null, insConc=null;
  if(bw!=null && insDose!=null && bagVol!=null){
    insUnits = insDose*bw;              // total U regular insulin to draw up
    insConc  = insUnits/bagVol;         // U/mL in the bag
  }
  // pump-rate scale so the bag delivers the standard target dose regardless of recipe/weight
  // std mL/hr (2.2 or 1.1 U/kg in 250 mL): 10/7/5/(3–5)/stop  ->  scale = (bagVol/250)·(defaultDose/insDose)
  const insScale = bagVol!=null && insDose!=null ? (bagVol/250)*(defaultDose/insDose) : null;
  const topRate  = insScale!=null ? 10*insScale : null;
  const bagHours = topRate!=null && topRate>0 ? bagVol/topRate : null;
  // insulin-line volume as % of maintenance (small-patient overload flag)
  const insLineMlDay = topRate!=null ? topRate*24 : null;
  const insLinePctMaint = maintDay!=null && insLineMlDay!=null ? (insLineMlDay/maintDay)*100 : null;
  const insSmallFlag = (insLinePctMaint!=null && insLinePctMaint>25);
  // direct syringe-pump / fixed-rate weight-based dosing
  const insLowUhr  = bw!=null ? 0.05*bw : null;
  const insHighUhr = bw!=null ? 0.10*bw : null;
  // FRI: constant mL/hr to deliver 0.05 / 0.10 U/kg/h from the chosen bag (weight-independent)
  const friLowRate  = bagVol!=null && insDose!=null ? 0.05*bagVol/insDose : null;
  const friHighRate = bagVol!=null && insDose!=null ? 0.10*bagVol/insDose : null;
  // IM Actrapid doses (U per injection)
  const imLoad      = bw!=null ? 0.2*bw : null;
  const imHourly    = bw!=null ? 0.1*bw : null;
  const imMaintLow  = bw!=null ? 0.1*bw : null;
  const imMaintHigh = bw!=null ? 0.3*bw : null;

  render({cls,tag,label,desc,confidence,missing,invalidInputs,
    effOsm,totOsm,totOsmExclUrea,measuredOsm,ureaRaw,na,k,cl,naKatz,naHillier,naCorr,targetNa,
    hyper,severeHyper,acidStatus,dkaAcidosis,noHhsAcidosis,hyperosm,severeOsm,dkaKetosis,hhsMinimalKetones,anyKetosis,confirmedCrisis,
    ketVal,ketDesc,ketSource:S.ketSource,
    gluM,gluMg,ph,hco3,bhb,bhbDkaCut,bhbConcernCut,anionGap,anionGapHigh,agUpper,dmEvidence:S.dmEvidence,sglt2:S.sglt2,
    fwd,deficitL,maintDay,maintHr,totalRate,bw,dehy,
    naGap,minHoursNa,ks,maxKfluid,kRateExceeded,
    insUnits,insDose,bagVol,insConc,insScale,defaultDose,topRate,bagHours,
    insLineMlDay,insLinePctMaint,insSmallFlag,insLowUhr,insHighUhr,
    insProtocol:S.insProtocol,friLowRate,friHighRate,imLoad,imHourly,imMaintLow,imMaintHigh});
}

function statFlag(cls){ return cls?(' flag-'+cls):''; }

// Name the terms that actually went into the total osmolality, and the ones that were skipped.
function osmFormula(d, html){
  let s='2·Na + glucose'+(d.totOsmExclUrea?'':' + urea');
  if(d.totOsmExclUrea){ s+=' · '+(html?'<b>urea not entered</b>':'urea not entered'); }
  return s;
}

function render(d){
  const out = $('out');
  let html='';
  lastD = d;

  // display-unit helpers (glucose + electrolyte/osmolality labels follow the toggles)
  const gU = S.gluUnit==='mmol' ? 'mmol/L' : 'mg/dL';
  const gShow = mmol => mmol==null ? '—' : (S.gluUnit==='mmol' ? fmt(mmol) : fmt0(mmol*GLU_MGDL_PER_MMOL));
  const naU = naUnitLabel();
  const osmU = osmUnitLabel();

  // VERDICT
  const vc = {dka:'v-dka',hhs:'v-hhs',mixed:'v-mixed',edka:'v-edka',none:'v-none'}[d.cls];
  html += `<div class="verdict ${vc}" role="status" aria-live="polite" aria-atomic="true">
    <div class="tag">${d.tag}</div>
    <div class="big">${d.label}</div>
    <p>${d.desc}</p>
    <div class="confidence">${d.confidence}</div>
  </div>`;

  if(d.invalidInputs.length){
    html += `<div class="callout warn" role="alert"><b>Correct these values:</b><ul class="missing-list">${d.invalidInputs.map(x=>`<li>${x}</li>`).join('')}</ul></div>`;
  }
  if(d.missing.length){
    html += `<div class="callout amber"><b>Still missing or unconfirmed:</b><ul class="missing-list">${d.missing.map(x=>`<li>${x}</li>`).join('')}</ul></div>`;
  }
  if(['dka','hhs','mixed','edka'].includes(d.cls)){
    html += `<div class="callout warn"><b>Emergency pattern.</b> This result warrants immediate inpatient assessment and serial monitoring. It identifies the biochemical pattern; it does not establish the trigger, exclude concurrent disease, or replace repeat testing.</div>`;
  }

  // CRITERIA
  const statusMark = status => {
    const m={y:['y','✓','met'],n:['n','×','not met'],u:['u','?','unknown'],c:['c','!','conflicting/partial']}[status];
    return `<span class="mark ${m[0]}" title="${m[2]}" aria-label="${m[2]}">${m[1]}</span>`;
  };
  const boolStatus = value => value==null?'u':(value?'y':'n');
  const ketCritStatus = d.dkaKetosis==null?'u':(d.dkaKetosis?'y':(d.anyKetosis?'c':'n'));
  const acidCritStatus = d.acidStatus==='met'?'y':(d.acidStatus==='not'?'n':(d.acidStatus==='unknown'?'u':'c'));
  const hhsAcidStatus = d.ph==null||d.hco3==null ? 'u' : (d.noHhsAcidosis?'y':'n');
  const acidValues = `pH ${d.ph!=null?fmt(d.ph,2):'—'} · HCO₃ ${d.hco3!=null?fmt(d.hco3):'—'}`;
  html += `<div class="card"><h2><span class="num">A</span> Diagnostic criteria met</h2>
    <div class="crit">
      <div class="crit-box dka"><h3>DKA pattern</h3>
        <div class="crit-item">${statusMark(boolStatus(d.hyper))}<span class="lbl">Classic hyperglycaemia (&gt;250 mg/dL / &gt;13.9 mmol/L)</span><span class="val">${gShow(d.gluM)}</span></div>
        <div class="crit-item">${statusMark(ketCritStatus)}<span class="lbl">Ketosis (blood BHB &gt;${d.bhbDkaCut} or positive urine ketones)</span><span class="val">${d.ketVal}</span></div>
        <div class="crit-item">${statusMark(acidCritStatus)}<span class="lbl">Acidaemia plus reduced bicarbonate (pH&lt;7.35 and HCO₃&lt;15)</span><span class="val">${acidValues}</span></div>
        <div class="crit-item">${statusMark(d.anionGapHigh==null?'u':(d.anionGapHigh?'y':'n'))}<span class="lbl">Raised anion gap (supportive, not required)</span><span class="val">${d.anionGap!=null?fmt(d.anionGap):'—'}</span></div>
      </div>
      <div class="crit-box hhs"><h3>HHS pattern</h3>
        <div class="crit-item">${statusMark(boolStatus(d.severeHyper))}<span class="lbl">Severe hyperglycaemia (&gt;600 mg/dL / &gt;33.3 mmol/L)</span><span class="val">${gShow(d.gluM)}</span></div>
        <div class="crit-item">${statusMark(boolStatus(d.hyperosm))}<span class="lbl">Effective osmolality &gt;320 mOsm/kg</span><span class="val">${d.effOsm!=null?fmt(d.effOsm):'—'}</span></div>
        <div class="crit-item">${statusMark(boolStatus(d.hhsMinimalKetones))}<span class="lbl">Absent or mild ketosis (blood BHB &lt;3 or urine negative/trace)</span><span class="val">${d.ketVal}</span></div>
        <div class="crit-item">${statusMark(hhsAcidStatus)}<span class="lbl">No significant acidosis (pH≥7.35 and HCO₃≥15)</span><span class="val">${acidValues}</span></div>
      </div>
    </div>
    <p class="status-note">✓ met · × not met · ? not entered · ! intermediate, partial or discordant. Borderline and discordant results require clinical interpretation; concurrent alkalosis can mask ketoacidosis.</p>
  </div>`;

  // OSMOLALITY + SODIUM
  html += `<div class="card"><h2><span class="num">B</span> Osmolality &amp; sodium</h2>
    <div class="result-grid">
      <div class="stat${statFlag(d.effOsm!=null?(d.effOsm>=330?'red':(d.effOsm>320?'amber':'green')):'')}">
        <div class="k">Effective osmolality (tonicity)</div>
        <div class="v">${fmt0(d.effOsm)} <span class="u">${osmU}</span></div>
        <div class="sub2">2·Na + glucose · normal ≈ 285–300</div>
      </div>
      <div class="stat">
        <div class="k">Total calculated osmolality</div>
        <div class="v">${fmt0(d.totOsm)} <span class="u">${osmU}</span></div>
        <div class="sub2">${d.totOsm==null?'needs Na &amp; glucose':osmFormula(d,true)}</div>
      </div>
      <div class="stat">
        <div class="k">Measured serum osmolality</div>
        <div class="v">${fmt0(d.measuredOsm)} <span class="u">${osmU}</span></div>
        <div class="sub2">optional laboratory value · not substituted into the effective-osmolality criterion</div>
      </div>
      <div class="stat${statFlag(d.anionGapHigh===true?'amber':'')}">
        <div class="k">Anion gap, K-inclusive</div>
        <div class="v">${fmt(d.anionGap)} <span class="u">${naU}</span></div>
        <div class="sub2">(Na + K) − (Cl + HCO₃) · compare with your analyser interval; guide only</div>
      </div>
      <div class="stat">
        <div class="k">Corrected Na — ×1.6 primary estimate</div>
        <div class="v">${fmt(d.naKatz)} <span class="u">${naU}</span></div>
        <div class="sub2">measured Na ${d.na!=null?fmt0(d.na):'—'} · used for free-water estimate · validated in dogs</div>
      </div>
      <div class="stat${statFlag(d.naHillier!=null&&d.targetNa!=null?(d.naHillier>d.targetNa+5?'amber':''):'')}">
        <div class="k">Corrected Na — ×2.4 secondary estimate</div>
        <div class="v">${fmt(d.naHillier)} <span class="u">${naU}</span></div>
        <div class="sub2">human-derived Hillier alternative · not validated for cats</div>
      </div>
    </div>
    <div class="callout"><b>Formula used for HHS:</b> effective osmolality = 2 × measured Na + glucose (SI). Urea is excluded because it is an ineffective osmole. Veterinary publications also use total-osmolality thresholds of 320–350 mOsm/kg, so interpret the number with the formula and the neurological/dehydration picture, not as a magic cliff.</div>
  </div>`;

  const isEmergencyPattern=['dka','hhs','mixed','edka'].includes(d.cls);
  const hypertonicityConcern=d.hyperosm===true || d.effOsm==null;
  if(!isEmergencyPattern){
    html += `<div class="card"><h2><span class="num">C</span> Treatment calculations paused</h2>
      <div class="callout amber"><b>No diabetic-crisis treatment output is being generated.</b> The entered pattern does not currently establish or strongly suspect DKA, HHS, mixed crisis or eDKA. Complete the missing tests, repeat discordant/borderline results and assess the whole patient before using any crisis fluid, potassium or insulin protocol.</div>
    </div>`;
  } else {

  // FLUIDS
  html += `<div class="card"><h2><span class="num">C</span> Fluid &amp; free water deficit</h2>
    <div class="result-grid">
      <div class="stat">
        <div class="k">Dehydration deficit</div>
        <div class="v">${fmt(d.deficitL)} <span class="u">L</span></div>
        <div class="sub2">${d.dehy!=null?d.dehy+'% × '+ (d.bw!=null?fmt(d.bw)+' kg':'BW'):'enter % + weight'} · ${d.deficitL!=null?fmt0(d.deficitL*1000)+' mL':''}</div>
      </div>
      <div class="stat">
        <div class="k">Free water deficit</div>
        <div class="v">${fmt(d.fwd)} <span class="u">L</span></div>
        <div class="sub2">${d.fwd!=null?'max[0, 0.6·BW·(Katz-corrected Na ÷ target − 1)] · '+fmt0(d.fwd*1000)+' mL':'needs weight, Na, glucose and target Na'}</div>
      </div>
      <div class="stat">
        <div class="k">Maintenance</div>
        <div class="v">${fmt0(d.maintHr)} <span class="u">mL/h</span></div>
        <div class="sub2">${fmt0(d.maintDay)} mL/day (${S.species==='dog'?'60':'50'} mL/kg/day)</div>
      </div>
      <div class="stat${statFlag(hypertonicityConcern&&S.hours<36?'amber':'')}">
        <div class="k">Unadjusted base-fluid estimate</div>
        <div class="v">${fmt0(d.totalRate)} <span class="u">mL/h</span></div>
        <div class="sub2">dehydration deficit over ${S.hours} h + maintenance only · not safety-validated</div>
      </div>
    </div>
    ${hypertonicityConcern&&S.hours<36?`<div class="callout warn"><b>Hypertonicity pace warning.</b> A 24-hour deficit plan may be too fast when effective osmolality is above 320 mOsm/kg${d.effOsm==null?' or cannot yet be calculated because sodium is missing':''}. Consider 36–48 hours or longer, then titrate to serial sodium, glucose, effective osmolality, urine output, haemodynamics and neurological status.</div>`:''}
    <div class="callout amber"><b>Estimate only.</b> This rate excludes ongoing losses, urine output, enteral intake, dextrose/insulin carrier lines, cardiac/renal limits and any free-water strategy. If shock is present, give small isotonic crystalloid aliquots and reassess; deduct resuscitation volume from the remaining deficit rather than automatically adding it on top. Choose the isotonic fluid and sodium content for the individual patient.</div>
  </div>`;

  // SAFE CORRECTION RATES
  let naSafeRow='';
  if(d.naGap!=null && d.naGap>0){
    const safeHoursDisplay=Math.ceil(d.minHoursNa*10)/10;
    naSafeRow = `<div class="callout warn"><b>Hypernatraemia on corrected Na (${fmt(d.naGap)} ${naU} above target).</b> Do not drop sodium/osmolality faster than <b>0.5 ${naU}/h</b>. Minimum arithmetic correction time ≥ <b>${fmt(safeHoursDisplay)} h</b>. Replace the free water deficit slowly and recheck Na q2–4h. Too-fast correction risks cerebral oedema.</div>`;
  } else if(d.naGap!=null){
    naSafeRow = `<div class="callout"><b>Corrected Na at/below target.</b> Main risk is osmolality falling too fast as glucose drops — keep the glucose fall in range (below) and recheck electrolytes q2–4h.</div>`;
  }
  html += `<div class="card"><h2><span class="num">D</span> Safe correction rates</h2>
    <div class="result-grid">
      <div class="stat">
        <div class="k">Max Na⁺ change</div>
        <div class="v">0.5 <span class="u">${naU}/h</span></div>
        <div class="sub2">≤ 10–12 ${naU} per 24 h</div>
      </div>
      <div class="stat">
        <div class="k">Target glucose fall</div>
        <div class="v">${S.gluUnit==='mmol'?'2.8–4.2':'50–75'} <span class="u">${gU}/h</span></div>
        <div class="sub2">${S.gluUnit==='mmol'?'50–75 mg/dL/h':'2.8–4.2 mmol/L/h'} · not faster</div>
      </div>
      <div class="stat">
        <div class="k">Add dextrose when glucose &lt;</div>
        <div class="v">${S.gluUnit==='mmol'?'14':'250'} <span class="u">${gU}</span></div>
        <div class="sub2">${S.gluUnit==='mmol'?'250 mg/dL':'14 mmol/L'} · keep insulin running to clear ketones</div>
      </div>
      <div class="stat">
        <div class="k">Effective osm fall</div>
        <div class="v">≤ 3 <span class="u">${osmU}/h</span></div>
        <div class="sub2">conservative tonicity ceiling; veterinary recommendations vary · recalculate q1–2 h in HHS</div>
      </div>
    </div>
    ${naSafeRow}
  </div>`;

  // POTASSIUM
  let kBody = '<p class="hint">Enter serum K⁺ to get the supplementation scale.</p>';
  if(d.ks){
    const kAmtU = S.system==='imperial' ? 'mEq' : 'mmol';
    const maxKDisplay = d.maxKfluid!=null ? Math.floor(d.maxKfluid*10)/10 : null;
    const delayInsulin = d.k!=null && d.k<3.5;
    kBody = `<div class="table-scroll"><table>
      <tr><th>Serum K⁺ (${naU})</th><th class="num">KCl to add (${kAmtU}/L fluid)</th></tr>
      ${[['> 5.0',0],['3.6 – 5.0',20],['3.1 – 3.5',30],['2.6 – 3.0',40],['2.1 – 2.5',60],['≤ 2.0',80]].map(r=>{
        const active = r[1]===d.ks.add;
        return `<tr class="${active?'hl':''}"><td>${r[0]}</td><td class="num">${r[1]}</td></tr>`;
      }).join('')}
    </table></div>
    <div class="callout ${d.kRateExceeded||delayInsulin?'warn':''}"><b>${d.ks.note}</b>${delayInsulin?' <b>Withhold insulin until K⁺ is at least 3.5 mmol/L and replacement is underway.</b>':''}${d.maxKfluid!=null?` Do not exceed <b>0.5 ${kAmtU}/kg/h total KCl across every line</b> — at this concentration that caps this line at <b>${fmt(maxKDisplay)} mL/h</b>.`:''}${d.kRateExceeded?` The unadjusted base-fluid estimate (${fmt0(d.totalRate)} mL/h) exceeds that cap; reduce total potassium delivery/concentration and recalculate all K-containing lines.`:''} Confirm urine production and renal status first; mix the bag thoroughly, use an infusion pump and remeasure K⁺ frequently.</div>`;
  }
  html += `<div class="card"><h2><span class="num">E</span> Potassium supplementation</h2>${kBody}</div>`;

  // INSULIN — three selectable protocols
  const dd = d.defaultDose, sc = d.insScale;
  const rr = x => { if(sc==null) return '—'; const v=x*sc; return fmt(v,1); };  // pump rate mL/h
  const du = x => (x*dd/250).toFixed(3);                                              // delivered U/kg/h
  const proto = d.insProtocol;
  const titles = {vri:'variable-rate CRI (sliding scale)', fri:'fixed-rate CRI', im:'intermittent IM Actrapid'};

  const typeCallout = `<div class="callout warn"><b>These displayed dose calculations are for regular (soluble/neutral) insulin only</b> — e.g. Actrapid®, Humulin® R, Novolin® R. Do not substitute lente/Vetsulin®/Caninsulin®, glargine, detemir, PZI or another product into this recipe. Alternative specialist protocols, including feline glargine protocols, require their own dosing instructions.</div>`;
  const timingCallout = `<div class="callout warn"><b>Timing.</b> Do <b>not</b> start insulin until perfusion is restored, initial rehydration is underway and K⁺ is at least 3.5 mmol/L. Insulin drives K⁺ and phosphate into cells${proto==='im'?', and IM absorption is erratic during shock':''}.${hypertonicityConcern?' With known or possible hypertonicity, prioritise fluids and reassess glucose and tonicity before insulin; a longer delay and lower clinician-selected dose may be appropriate.':''}</div>`;

  let insGate='';
  let insBody='';

  const bagProtocolReady=d.bw!=null&&d.insDose!=null&&d.bagVol!=null&&d.insConc!=null;
  if(d.cls==='edka'){
    const felineEdka=S.species==='cat'
      ? 'Current AAHA feline guidance starts fluids with at least 5% dextrose, adds insulin only once glucose is consistently above 150 mg/dL on dextrose and potassium is adequate, and may require 7.5% or more dextrose.'
      : 'Use a species-appropriate specialist protocol with dextrose support, conservative insulin and serial ketone/acid–base monitoring.';
    insGate=`<div class="callout warn"><b>Generic insulin tables are suppressed for possible eDKA.</b> A glucose-only sliding scale can stop insulin while ketogenesis is still active, and the generic fixed-rate dextrose table is not an eDKA protocol. ${felineEdka} Stop any SGLT2 inhibitor and use a clinician-directed eDKA protocol with hourly glucose plus serial BHB, electrolytes and acid–base status. <a href="https://www.aaha.org/resources/2026-aaha-diabetes-management-guidelines-for-cats/section-12-diabetic-ketoacidosis-in-cats/" target="_blank" rel="noopener">AAHA 2026 feline guidance</a>.</div>`;
  }
  else if(hypertonicityConcern){
    insGate=`<div class="callout warn"><b>Generic DKA insulin tables are suppressed because hypertonicity is ${d.effOsm==null?'not yet assessable':'present'}.</b> In HHS, mixed crisis, hypertonic DKA or any DKA without a current sodium result, insulin timing/rate must be selected against serial glucose, sodium, tonicity, perfusion and neurological status. The standard 0.05–0.10 U/kg/h DKA tables may lower glucose and osmolality too quickly; use a fluid-first, senior-clinician-directed protocol.</div>`;
  }
  else if(d.dmEvidence!=='yes'){
    insGate=`<div class="callout amber"><b>Insulin calculations are paused until diabetes mellitus is supported.</b> The biochemical pattern is concerning, but the diabetes context is currently ${d.dmEvidence==='no'?'“not established”':'unknown'}. Confirm DM independently or use a senior-clinician-selected protocol while the differential diagnosis is clarified.</div>`;
  }
  else if(!d.confirmedCrisis){
    insGate='<div class="callout amber"><b>Insulin calculations are paused.</b> The current result is an urgent suspected pattern, but the full crisis criteria are not yet established. Complete/repeat the missing or discordant tests and choose a patient-specific protocol.</div>';
  }
  else if(d.k==null || d.k<3.5){
    insGate=`<div class="callout warn"><b>Insulin calculations are paused until potassium is safe.</b> ${d.k==null?'Enter a current K⁺ result.':'K⁺ is below 3.5 mmol/L.'} Restore perfusion, confirm urine production/renal status, begin indicated replacement and recheck before insulin.</div>`;
  }
  else if((proto==='vri'||proto==='fri')&&!bagProtocolReady){
    insGate='<div class="callout amber"><b>Insulin recipe paused.</b> Enter a valid body weight, insulin bag dose and carrier volume. No pump rate should be used until the bag concentration can be prepared and independently checked.</div>';
  }
  else if(proto==='im'&&d.bw==null){
    insGate='<div class="callout amber"><b>IM doses paused.</b> Enter a valid body weight before calculating any insulin dose.</div>';
  }
  else if(proto==='vri'){
    const insBands = [
      ['&gt;19.4','&gt;350',10,'none'],['13.9–19.4','250–350',7,'none'],
      ['8.3–13.9','150–250',5,'2.5%'],['5.6–8.3','100–150',[3,5],'5%'],['≤5.6','≤100',0,'escalate dextrose; urgent reassessment'],
    ];
    const insRows = insBands.map(([gm,gd,std,dex])=>{
      let pump,deliv;
      if(std===0){pump='temporary hold';deliv='rapid recheck';}
      else if(Array.isArray(std)){pump=`${rr(std[0])}–${rr(std[1])}`;deliv=`${du(std[0])}–${du(std[1])}`;}
      else{pump=`${rr(std)}`;deliv=du(std);}
      return `<tr><td>${gm}<br><span style="color:var(--muted)">(${gd})</span></td><td class="num">${pump}</td><td class="num">${deliv}</td><td>${dex}</td></tr>`;
    }).join('');
    insBody = `
    <div class="result-grid">
      <div class="stat"><div class="k">Regular insulin to draw up</div><div class="v">${fmt(d.insUnits)} <span class="u">units</span></div><div class="sub2">${fmt(d.insDose)} U/kg × ${d.bw!=null?fmt(d.bw)+' kg':'BW'}</div></div>
      <div class="stat"><div class="k">Into 0.9% NaCl</div><div class="v">${fmt0(d.bagVol)} <span class="u">mL</span></div><div class="sub2">→ ${d.insConc!=null?fmt(d.insConc,3)+' U/mL':'—'} in the bag</div></div>
      <div class="stat"><div class="k">Prime / discard line</div><div class="v">~50 <span class="u">mL</span></div><div class="sub2">insulin binds tubing — saturate first</div></div>
      <div class="stat"><div class="k">Bag lasts (top rate)</div><div class="v">${d.bagHours!=null?fmt0(d.bagHours):'—'} <span class="u">h</span></div><div class="sub2">at ${rr(10)} mL/h · <b>replace ≤24 h</b> regardless</div></div>
    </div>
    <p class="hint" style="margin-top:14px">Adjust the insulin pump rate every 1–2 h to the glucose (aim for a ${S.gluUnit==='mmol'?'2.8–4.2 mmol/L/h':'50–75 mg/dL/h'} fall). <b>Delivered dose is the same for any body weight</b> — weight is already in the bag concentration.</p>
    <div class="table-scroll"><table>
      <tr><th>Blood glucose</th><th class="num">Pump rate (mL/h)</th><th class="num">Delivers (U/kg/h)</th><th>Dextrose</th></tr>
      ${insRows}
    </table></div>
    <p class="refs" style="margin-top:6px">Pump rate mL/h · delivered dose U/kg/h. At the default ${fmt(dd)} U/kg / 250 mL these are the classic 10 / 7 / 5 mL/h rates; changing the bag or U/kg recomputes the rate to keep the same delivered dose.</p>
    ${d.insSmallFlag ? `<div class="callout amber"><b>Small-patient volume warning.</b> The insulin line at ${rr(10)} mL/h delivers ~${fmt0(d.insLineMlDay)} mL/day — about ${fmt0(d.insLinePctMaint)}% of this patient's maintenance. Count it in the total fluid plan, or use FRI/syringe-pump dosing to avoid overload.</div>` : ''}
    <p class="refs">Merck/DiBartola/Macintire sliding-scale CRI. A low-glucose hold is temporary: escalate dextrose, recheck promptly and resume a clinician-selected dose while ketosis persists. Replace the insulin–saline bag every 24 h (IV regular insulin has a ~5–10 min plasma half-life — effect is entirely infusion-dependent; the mixed bag also loses potency to degradation and plastic adsorption).</p>`;
  }

  else if(proto==='fri'){
    const dxBands = [
      ['&gt;13.9','&gt;250','0.9% NaCl — no dextrose'],
      ['8.3–13.9','150–250','2.5% dextrose'],
      ['5.6–8.3','100–150','5% dextrose'],
      ['&lt;5.6','&lt;100','7.5% dextrose; if still falling, ↓ insulin rate'],
    ];
    const dxRows = dxBands.map(([gm,gd,dx])=>`<tr><td>${gm}<br><span style="color:var(--muted)">(${gd})</span></td><td>${dx}</td></tr>`).join('');
    const friLo = d.friLowRate, friHi = d.friHighRate;
    const rnd = v => v==null?'—':fmt(v,1);
    insBody = `
    <div class="result-grid">
      <div class="stat"><div class="k">Regular insulin to draw up</div><div class="v">${fmt(d.insUnits)} <span class="u">units</span></div><div class="sub2">${fmt(d.insDose)} U/kg × ${d.bw!=null?fmt(d.bw)+' kg':'BW'} → ${d.insConc!=null?fmt(d.insConc,3)+' U/mL':'—'}</div></div>
      <div class="stat flag-calc"><div class="k">Constant insulin rate</div><div class="v">${rnd(friLo)}–${rnd(friHi)} <span class="u">mL/h</span></div><div class="sub2">= 0.05–0.10 U/kg/h · start low; do not routinely chase each glucose result</div></div>
      <div class="stat"><div class="k">Into 0.9% NaCl</div><div class="v">${fmt0(d.bagVol)} <span class="u">mL</span></div><div class="sub2">prime/discard ~50 mL · replace ≤24 h</div></div>
      <div class="stat"><div class="k">Direct syringe-pump</div><div class="v">${d.bw!=null?fmt(d.insLowUhr,2)+'–'+fmt(d.insHighUhr,2):'—'} <span class="u">U/h</span></div><div class="sub2">0.05–0.10 U/kg/h — lowest fluid volume</div></div>
    </div>
    <p class="hint" style="margin-top:14px">Insulin ordinarily runs at one selected rate while glucose is managed with <b>dextrose</b> in a separate line. Recheck BG q1–2 h; reduce or temporarily hold insulin and reassess if hypoglycaemia persists despite dextrose escalation.</p>
    <div class="table-scroll"><table>
      <tr><th>Blood glucose (mmol/L)</th><th>Dextrose in the fluid line</th></tr>
      ${dxRows}
    </table></div>
    <p class="refs">Fixed-rate CRI: insulin held constant to keep switching off ketogenesis; glycaemia controlled with dextrose. Simpler to run and avoids repeated pump changes. Keep going until ketones clear and the patient is eating. Replace the insulin bag every 24 h (IV regular insulin half-life ~5–10 min; degradation/adsorption).</p>`;
  }

  else { // IM
    insBody = `
    <div class="callout warn"><b>Withhold IM insulin for the first 1–2 h.</b> Give IV crystalloids first — IM absorption is erratic and unpredictable while the patient is dehydrated or shocky. Inject into <b>forelimb muscle</b> once rehydration is underway.</div>
    <div class="result-grid">
      <div class="stat flag-calc"><div class="k">Loading dose (once)</div><div class="v">${d.imLoad!=null?fmt(d.imLoad,1):'—'} <span class="u">U IM</span></div><div class="sub2">0.2 U/kg regular insulin, after initial fluids</div></div>
      <div class="stat"><div class="k">Then hourly</div><div class="v">${d.imHourly!=null?fmt(d.imHourly,1):'—'} <span class="u">U IM</span></div><div class="sub2">0.1 U/kg every 1 h · check BG hourly</div></div>
      <div class="stat"><div class="k">Target glucose fall</div><div class="v">${S.gluUnit==='mmol'?'2.8–4.2':'50–75'} <span class="u">${S.gluUnit==='mmol'?'mmol/L/h':'mg/dL/h'}</span></div><div class="sub2">gradual — if dropping fast, skip a dose &amp; recheck</div></div>
      <div class="stat"><div class="k">Maintenance (once BG &lt; ${S.gluUnit==='mmol'?'14':'250'})</div><div class="v">${d.imMaintLow!=null?fmt(d.imMaintLow,1)+'–'+fmt(d.imMaintHigh,1):'—'} <span class="u">U</span></div><div class="sub2">0.1–0.3 U/kg SC q4–6 h + add dextrose as indicated</div></div>
    </div>
    <p class="hint" style="margin-top:14px">How to run it:</p>
    <ul class="tight">
      <li><b>1.</b> Stabilise with IV fluids for 1–2 h first. Then give the loading dose (${d.imLoad!=null?fmt(d.imLoad,1)+' U':'0.2 U/kg'}) IM.</li>
      <li><b>2.</b> Give ${d.imHourly!=null?fmt(d.imHourly,1)+' U':'0.1 U/kg'} IM every hour; measure BG hourly and aim for a gradual fall.</li>
      <li><b>3.</b> If BG falls too fast, skip the next hourly dose and recheck.</li>
      <li><b>4.</b> Once BG &lt; ${S.gluUnit==='mmol'?'14 mmol/L (250 mg/dL)':'250 mg/dL'}, <b>do not stop insulin solely because glucose has normalised</b> — add dextrose as indicated and transition to ${d.imMaintLow!=null?fmt(d.imMaintLow,1)+'–'+fmt(d.imMaintHigh,1)+' U':'0.1–0.3 U/kg'} SC every 4–6 h while reassessing ketones and acid–base status.</li>
    </ul>
    <p class="refs">Low-dose IM protocol (Chastain/Nichols, Macintire) — used when no CRI pump is available. Insulin must keep going (with dextrose) to shut down ketone production even after glucose normalises.</p>`;
  }

  html += `<div class="card accordion" id="acc-ins"><h2 class="accordion-title"><button type="button" class="accordion-head" aria-expanded="${accState['acc-ins']?'true':'false'}" aria-controls="acc-ins-body"><span class="title"><span class="num">F</span> Insulin — ${titles[proto]}</span><span class="chev" aria-hidden="true">▸</span></button></h2>
    ${insGate?`<div class="accordion-status" role="status">${insGate}</div>`:''}
    <div class="body" id="acc-ins-body">
    ${typeCallout}
    ${timingCallout}
    ${insBody}
    </div>
  </div>`;

  // WORKFLOW
  html += `<div class="card accordion" id="acc-flow"><h2 class="accordion-title"><button type="button" class="accordion-head" aria-expanded="${accState['acc-flow']?'true':'false'}" aria-controls="acc-flow-body"><span class="title"><span class="num">G</span> Stabilisation order of play</span><span class="chev" aria-hidden="true">▸</span></button></h2>
    <div class="body" id="acc-flow-body">
    <ul class="tight">
      <li><b>1. Resuscitate.</b> Treat shock/hypovolaemia first with an isotonic bolus; get IV access, baseline PCV/TS, glucose, electrolytes, blood gas, BHB.</li>
      <li><b>2. Rehydrate.</b> Use an individualised isotonic crystalloid plan (balanced fluid or saline as appropriate to sodium, chloride, acid–base status and comorbidity). Recheck electrolytes in 2–4 h. Fluids alone start dropping glucose and osmolality.</li>
      <li><b>3. Potassium.</b> Supplement per section E before and during insulin. Never run insulin into a hypokalaemic patient.</li>
      <li><b>4. Insulin.</b> Once volume-restored and K⁺ ≥ 3.5, start the CRI (section F). Target a controlled glucose fall, add dextrose at &lt;14 mmol/L.</li>
      <li><b>5. Go slow with hypertonicity.</b> Correct sodium/osmolality no faster than the section D limits — the brain has adapted and may swell if tonicity falls too quickly.</li>
      <li><b>6. Monitor phosphate &amp; magnesium proactively.</b> Both can fall rapidly with fluids and insulin. Trend them during treatment and supplement to the patient, not only after weakness or haemolysis appears.</li>
    </ul>
    </div>
  </div>`;
  }

  out.innerHTML = html;

  // Unit-trap guard on the urea/BUN field. The field defaults to urea mmol/L, so a BUN in mg/dL
  // typed straight in is silently accepted and overstates total osmolality by ~2.8x. Flag the
  // values that are implausible for the selected unit and offer a relabel, rather than guessing.
  const uw = $('ureaWarn'), uv = d.ureaRaw;
  if(uv==null || uv<=0){ uw.innerHTML = ''; }
  else if(S.ureaUnit==='mmol' && uv>=30){
    const asUrea = uv/2.8;
    uw.innerHTML = `<b style="color:var(--amber)">Check the unit.</b> ${fmt(uv)} mmol/L urea is severe azotaemia — real in a crisis patient, but this is also where a <b>BUN in mg/dL</b> lands if the toggle was missed. Read as a BUN it is ${fmt(asUrea)} mmol/L urea, which would make the total osmolality above ${fmt0(uv-asUrea)} ${osmU} too high. <a href="#" data-urea-reinterpret="mgdl" style="color:var(--amber);font-weight:700">Treat this figure as BUN mg/dL</a> — relabels, does not convert.`;
  }
  else if(S.ureaUnit==='mgdl' && uv<=6){
    const asBun = uv*2.8;
    uw.innerHTML = `<b style="color:var(--amber)">Check the unit.</b> A BUN of ${fmt(uv)} mg/dL is implausibly low for a diabetic crisis patient. If this figure is <b>urea in mmol/L</b>, the BUN is ${fmt0(asBun)} mg/dL. <a href="#" data-urea-reinterpret="mmol" style="color:var(--amber);font-weight:700">Treat this figure as urea mmol/L</a> — relabels, does not convert.`;
  }
  else uw.innerHTML = '';
  const ureaRelabel=uw.querySelector('[data-urea-reinterpret]');
  if(ureaRelabel) ureaRelabel.addEventListener('click',e=>{e.preventDefault();reinterpretUrea(ureaRelabel.getAttribute('data-urea-reinterpret'));});

  // accordions — persist open/closed state across re-renders (calc runs on every keystroke)
  out.querySelectorAll('.accordion').forEach(acc=>{
    if(accState[acc.id]) acc.classList.add('open');
    const trigger=acc.querySelector('.accordion-head');
    trigger.onclick = ()=>{
      acc.classList.toggle('open');
      accState[acc.id] = acc.classList.contains('open');
      trigger.setAttribute('aria-expanded',accState[acc.id]?'true':'false');
    };
  });
}

// ---- Copy / export --------------------------------------------------------
function buildReport(){
  const d = lastD;
  if(!d) return '';
  const naU  = S.system==='imperial' ? 'mEq/L' : 'mmol/L';
  const osmU = 'mOsm/kg';
  const gU   = S.gluUnit==='mmol' ? 'mmol/L' : 'mg/dL';
  const kAmtU= S.system==='imperial' ? 'mEq' : 'mmol';
  const wU   = S.weightUnit;
  const V = (v,dec=1)=> v==null||!isFinite(v) ? '—' : (Math.round(v*10**dec)/10**dec);
  const bwDisp  = d.bw==null ? null : (wU==='kg' ? d.bw : d.bw*LB_PER_KG);
  const gluDisp = S.gluUnit==='mmol' ? d.gluM : d.gluMg;
  const ureaDisp = num('urea'); // shown in whatever unit is entered
  let ts=''; try{ ts=new Date().toLocaleString(); }catch(e){}
  const L=[];
  L.push('DKA vs HHS CRISIS CALCULATOR — ASK A VET(TM)');
  if(ts) L.push('Generated: '+ts);
  L.push('Units: '+(S.system==='imperial'?'Imperial (US)':'Metric (SI)'));
  L.push('');
  L.push('PATIENT');
  L.push('  Species: '+(S.species==='dog'?'Dog':'Cat'));
  L.push('  Diabetes context: '+({yes:'known / supported',no:'not established',unknown:'unknown'}[d.dmEvidence]));
  if(S.species==='cat') L.push('  SGLT2 inhibitor exposure: '+({yes:'yes',no:'no',unknown:'unknown'}[d.sglt2]));
  L.push('  Weight: '+(bwDisp==null?'—':V(bwDisp)+' '+wU)+(bwDisp!=null&&wU!=='kg'?'  ('+V(d.bw)+' kg used in calcs)':''));
  L.push('  Dehydration: '+(d.dehy==null?'—':d.dehy+' %'));
  L.push('');
  L.push('BLOODS');
  L.push('  Glucose: '+(gluDisp==null?'—':V(gluDisp, S.gluUnit==='mmol'?1:0)+' '+gU));
  L.push('  Sodium (Na+): '+(d.na==null?'—':d.na+' '+naU));
  L.push('  Potassium (K+): '+(d.k==null?'—':d.k+' '+naU));
  L.push('  Chloride (Cl-): '+(d.cl==null?'—':d.cl+' '+naU));
  L.push('  Urea/BUN: '+(ureaDisp==null?'—':ureaDisp+' '+(S.ureaUnit==='mmol'?'mmol/L (urea)':'mg/dL (BUN)')));
  L.push('  Venous pH: '+(d.ph==null?'—':d.ph));
  L.push('  Bicarbonate (HCO3): '+(d.hco3==null?'—':d.hco3+' mmol/L'));
  L.push('  Ketones: '+d.ketDesc);
  L.push('');
  L.push('CLASSIFICATION: '+d.label+' ['+d.confidence+']');
  if(d.desc) L.push('  '+d.desc);
  if(d.missing.length) L.push('  Missing/unconfirmed: '+d.missing.join('; '));
  if(d.invalidInputs.length) L.push('  Invalid inputs: '+d.invalidInputs.join('; '));
  L.push('');
  L.push('OSMOLALITY & SODIUM');
  L.push('  Effective osmolality (tonicity): '+(d.effOsm==null?'—':V(d.effOsm,0)+' '+osmU));
  L.push('  Total calc. osmolality: '+(d.totOsm==null?'— (needs Na & glucose)':V(d.totOsm,0)+' '+osmU+'  ['+osmFormula(d,false)+']'));
  L.push('  Measured serum osmolality: '+(d.measuredOsm==null?'—':V(d.measuredOsm,0)+' '+osmU));
  L.push('  Anion gap, K-inclusive: '+(d.anionGap==null?'—':V(d.anionGap)+' '+naU)+(d.anionGapHigh===true?' [above generic species guide; check analyser interval]':''));
  L.push('  Corrected Na — x1.6 primary: '+(d.naKatz==null?'—':V(d.naKatz)+' '+naU)+'   [used for free-water estimate]');
  L.push('  Corrected Na — x2.4 secondary: '+(d.naHillier==null?'—':V(d.naHillier)+' '+naU)+'   [human-derived; not validated in cats]');
  L.push('  Target Na: '+V(d.targetNa)+' '+naU);
  if(!['dka','hhs','mixed','edka'].includes(d.cls)){
    L.push('');
    L.push('TREATMENT CALCULATIONS PAUSED');
    L.push('  The entered pattern does not currently establish or strongly suspect a diabetic crisis. Complete/repeat missing, borderline or discordant tests before using a crisis fluid, potassium or insulin protocol.');
    L.push('');
    L.push('For qualified veterinary use only — decision support, not a substitute for clinical judgement and serial monitoring.');
    L.push('ASK A VET(TM) clinical tools — Talk. Track. Trust.');
    return L.join('\n');
  }
  L.push('');
  L.push('FLUIDS');
  L.push('  Dehydration deficit: '+(d.deficitL==null?'—':V(d.deficitL,2)+' L ('+V(d.deficitL*1000,0)+' mL)'));
  L.push('  Free water deficit estimate: '+(d.fwd==null?'—':V(d.fwd,2)+' L ('+V(d.fwd*1000,0)+' mL)'));
  L.push('  Maintenance: '+(d.maintHr==null?'—':V(d.maintHr,0)+' mL/h ('+V(d.maintDay,0)+' mL/day)'));
  L.push('  Unadjusted base-fluid estimate: '+(d.totalRate==null?'—':V(d.totalRate,0)+' mL/h  [deficit over '+S.hours+' h + maintenance only]'));
  L.push('  This estimate excludes ongoing losses, urine output, parallel lines, comorbid limits and free-water strategy; deduct resuscitation volume from the remaining deficit.');
  if((d.hyperosm || d.effOsm==null) && S.hours<36) L.push('  ** Known or unassessed hypertonicity: a 24 h deficit plan may be too fast; enter sodium and consider 36–48 h or longer when tonicity is high. Titrate to serial tonicity, sodium and neurological status. **');
  L.push('');
  L.push('SAFE CORRECTION RATES');
  L.push('  Max Na change: 0.5 '+naU+'/h  (<= 10–12 '+naU+' per 24 h)');
  L.push('  Target glucose fall: '+(S.gluUnit==='mmol'?'2.8–4.2 mmol/L/h':'50–75 mg/dL/h')+'  (not faster)');
  L.push('  Add dextrose when glucose < '+(S.gluUnit==='mmol'?'14 mmol/L':'250 mg/dL'));
  L.push('  Effective osmolality fall: <= 3 '+osmU+'/h');
  if(d.naGap!=null && d.naGap>0) L.push('  ** Hypernatraemia: corrected Na is '+V(d.naGap)+' '+naU+' above target. Minimum arithmetic correction time >= '+V(Math.ceil(d.minHoursNa*10)/10,1)+' h. Recheck Na q2–4h. **');
  L.push('');
  L.push('POTASSIUM');
  if(d.ks){
    L.push('  Serum K+ '+(d.k==null?'':d.k+' '+naU)+' -> '+(d.ks.add===0?'hold KCl, recheck in 4–6 h':'add '+d.ks.add+' '+kAmtU+' KCl per litre'));
    if(d.k!=null && d.k<3.5) L.push('  ** Withhold insulin until K+ >=3.5 mmol/L and replacement is underway. **');
    if(d.maxKfluid!=null) L.push('  Do not exceed 0.5 '+kAmtU+'/kg/h TOTAL KCl across all lines -> this line cap '+V(Math.floor(d.maxKfluid*10)/10,1)+' mL/h'+(d.kRateExceeded?'  ** base-fluid estimate EXCEEDS this **':''));
    L.push('  Confirm urine production/renal status; mix thoroughly, use an infusion pump and remeasure K+ frequently.');
  } else L.push('  (enter serum K+ for the scale)');
  L.push('');
  const protoName = {vri:'VARIABLE-RATE CRI (sliding scale)', fri:'FIXED-RATE CRI', im:'INTERMITTENT IM ACTRAPID'}[d.insProtocol];
  L.push('INSULIN — '+protoName);
  L.push('  These calculations are for regular (soluble/neutral) insulin only (e.g. Actrapid, Humulin R). Do not substitute another product into this recipe; alternative specialist protocols require their own dosing instructions.');
  L.push('  Start only after rehydration (1-2 h) AND K+ >= 3.5.');
  const rr2 = x => d.insScale==null?'—':V(x*d.insScale,1);
  const du2 = x => (x*d.defaultDose/250).toFixed(3);
  const rnd2 = v => v==null?'—':V(v,1);
  const bagReady=d.bw!=null&&d.insDose!=null&&d.bagVol!=null&&d.insConc!=null;
  if(d.cls==='edka'){
    L.push('  GENERIC TABLES SUPPRESSED FOR POSSIBLE eDKA. A glucose-only VRI can stop insulin while ketogenesis remains active, and the generic FRI dextrose table is not an eDKA protocol. Use a clinician-directed eDKA protocol with dextrose support and serial glucose/BHB/electrolyte/acid-base monitoring.');
    if(S.species==='cat') L.push('  AAHA feline guidance: begin fluids with at least 5% dextrose; add insulin only once glucose is consistently >150 mg/dL on dextrose and K+ is adequate; 7.5% or more dextrose may be needed. Stop any SGLT2 inhibitor.');
  } else if(d.hyperosm || d.effOsm==null){
    L.push('  GENERIC DKA TABLES SUPPRESSED BECAUSE HYPERTONICITY IS PRESENT OR NOT YET ASSESSABLE. Enter sodium and use a fluid-first, senior-clinician-directed protocol; standard 0.05–0.10 U/kg/h tables may lower glucose/tonicity too quickly.');
  } else if(d.dmEvidence!=='yes'){
    L.push('  Insulin calculations paused until diabetes mellitus is independently supported; the current diabetes context is '+(d.dmEvidence==='no'?'not established':'unknown')+'.');
  } else if(!d.confirmedCrisis){
    L.push('  Insulin calculations paused: urgent suspected pattern, but full crisis criteria are not yet established. Complete/repeat missing or discordant tests.');
  } else if(d.k==null || d.k<3.5){
    L.push('  Insulin calculations paused until a current K+ is entered and K+ is >=3.5 mmol/L with replacement underway as indicated.');
  } else if((d.insProtocol==='vri'||d.insProtocol==='fri')&&!bagReady){
    L.push('  Recipe paused: valid body weight, bag dose and carrier volume are required.');
  } else if(d.insProtocol==='im'&&d.bw==null){
    L.push('  IM dose paused: valid body weight is required.');
  } else if(d.insProtocol==='vri'){
    L.push('  Recipe: '+(d.insUnits==null?'—':V(d.insUnits)+' U')+' ('+V(d.insDose)+' U/kg) into '+V(d.bagVol,0)+' mL 0.9% NaCl'+(d.insConc!=null?' = '+V(d.insConc,3)+' U/mL':'')+'. Prime/discard ~50 mL.');
    L.push('  Sliding scale [pump mL/h -> delivers U/kg/h] (same delivered dose at any body weight):');
    L.push('    >350 mg/dL (>19.4 mmol/L): '+rr2(10)+' mL/h -> '+du2(10)+' U/kg/h, no dextrose');
    L.push('    250-350 (13.9-19.4): '+rr2(7)+' mL/h -> '+du2(7)+' U/kg/h, no dextrose');
    L.push('    150-250 (8.3-13.9): '+rr2(5)+' mL/h -> '+du2(5)+' U/kg/h, +2.5% dextrose');
    L.push('    100-150 (5.6-8.3): '+rr2(3)+'-'+rr2(5)+' mL/h -> '+du2(3)+'-'+du2(5)+' U/kg/h, +5% dextrose');
    L.push('    <=100 (<=5.6): temporary insulin hold, escalate dextrose, urgent recheck and clinician-directed resumption while ketosis persists');
    L.push('  Bag lasts ~'+(d.bagHours==null?'—':V(d.bagHours,0))+' h at top rate; replace the mixed bag every 24 h (stability/adsorption; IV insulin half-life ~5-10 min).');
    if(d.insSmallFlag) L.push('  ** Small patient: insulin-line volume ~'+V(d.insLineMlDay,0)+' mL/day = '+V(d.insLinePctMaint,0)+'% of maintenance — count in fluid plan or use FRI/syringe-pump. **');
  } else if(d.insProtocol==='fri'){
    L.push('  Recipe: '+(d.insUnits==null?'—':V(d.insUnits)+' U')+' ('+V(d.insDose)+' U/kg) into '+V(d.bagVol,0)+' mL 0.9% NaCl'+(d.insConc!=null?' = '+V(d.insConc,3)+' U/mL':'')+'. Prime/discard ~50 mL.');
    L.push('  SELECTED insulin rate: '+rnd2(d.friLowRate)+'-'+rnd2(d.friHighRate)+' mL/h = 0.05-0.10 U/kg/h (start low; do not routinely chase each glucose result; reduce/hold and reassess if hypoglycaemia persists despite dextrose).');
    L.push('  Or syringe pump: '+(d.bw!=null?V(d.insLowUhr,2)+'-'+V(d.insHighUhr,2)+' U/h':'0.05-0.10 U/kg/h')+'.');
    L.push('  Manage glucose with DEXTROSE in a separate line (recheck BG q1-2h):');
    L.push('    >250 mg/dL (>13.9 mmol/L): 0.9% NaCl, no dextrose');
    L.push('    150-250 (8.3-13.9): 2.5% dextrose');
    L.push('    100-150 (5.6-8.3): 5% dextrose');
    L.push('    <100 (<5.6): 7.5% dextrose; if still falling, reduce insulin rate');
    L.push('  Replace the mixed bag every 24 h.');
  } else {
    L.push('  Withhold IM for first 1-2 h (give IV fluids first; erratic absorption when dehydrated). Inject forelimb muscle.');
    L.push('  Loading dose: '+(d.imLoad!=null?V(d.imLoad,1)+' U':'0.2 U/kg')+' IM once, after initial fluids.');
    L.push('  Then '+(d.imHourly!=null?V(d.imHourly,1)+' U':'0.1 U/kg')+' IM every 1 h; check BG hourly; aim for a gradual fall ('+(S.gluUnit==='mmol'?'2.8-4.2 mmol/L/h':'50-75 mg/dL/h')+').');
    L.push('  If BG drops fast: skip the next hourly dose and recheck.');
    L.push('  Once BG < '+(S.gluUnit==='mmol'?'14 mmol/L (250 mg/dL)':'250 mg/dL')+': add dextrose as indicated and transition to '+(d.imMaintLow!=null?V(d.imMaintLow,1)+'-'+V(d.imMaintHigh,1)+' U':'0.1-0.3 U/kg')+' SC q4-6h while reassessing ketones and acid-base status.');
  }
  L.push('');
  L.push('For qualified veterinary use only — decision support, not a substitute for clinical judgement and serial monitoring.');
  L.push('ASK A VET(TM) clinical tools — Talk. Track. Trust.');
  return L.join('\n');
}

function copyAll(btn){
  const text = buildReport();
  const done = ()=>{ const o=btn.textContent; btn.textContent='Copied ✓'; setTimeout(()=>{btn.textContent=o;},1600); };
  if(navigator.clipboard && navigator.clipboard.writeText){
    navigator.clipboard.writeText(text).then(done).catch(()=>legacyCopy(text,done));
  } else legacyCopy(text,done);
}
function legacyCopy(text,done){
  try{
    const ta=document.createElement('textarea');
    ta.value=text; ta.style.position='fixed'; ta.style.top='-1000px'; ta.style.opacity='0';
    document.body.appendChild(ta); ta.focus(); ta.select();
    const ok=document.execCommand('copy');
    document.body.removeChild(ta);
    if(ok){ done(); return; }
  }catch(e){}
  // last resort: show a modal for manual copy
  $('copyText').value=text;
  $('copyModal').classList.add('show');
  $('copyModal').setAttribute('aria-hidden','false');
  $('copyText').focus(); $('copyText').select();
}

function closeCopyModal(){
  $('copyModal').classList.remove('show');
  $('copyModal').setAttribute('aria-hidden','true');
  $('copyBtn').focus();
}

function emailResults(){
  const subject='Veterinary DKA vs HHS calculator result — '+(lastD?lastD.label:'classification');
  const body=buildReport();
  window.location.href='mailto:?subject='+encodeURIComponent(subject)+'&body='+encodeURIComponent(body);
}

function activateGroup(id,attr,value){
  $(id).querySelectorAll('button').forEach(b=>b.classList.toggle('active',b.getAttribute(attr)===String(value)));
  syncPressed(id);
}

function resetCalculator(){
  Object.assign(S,{system:'metric',species:'dog',dmEvidence:'unknown',gluUnit:'mmol',ureaUnit:'mmol',weightUnit:'kg',ketSource:'blood',urineKet:'unknown',sglt2:'unknown',hours:24,insProtocol:'vri'});
  dirty.targetNa=false; dirty.insDose=false;
  ['bw','dehy','glu','na','k','cl','urea','measOsm','ph','hco3','bhb'].forEach(id=>{$(id).value='';});
  $('bagVol').value='250';
  activateGroup('system','data-sys','metric');
  activateGroup('species','data-sp','dog');
  activateGroup('dmEvidence','data-v','unknown');
  activateGroup('wtUnit','data-u','kg');
  activateGroup('gluUnit','data-u','mmol');
  activateGroup('ureaUnit','data-u','mmol');
  activateGroup('ketSrc','data-src','blood');
  activateGroup('urineLevel','data-u','unknown');
  activateGroup('sglt2','data-v','unknown');
  activateGroup('hours','data-h','24');
  activateGroup('insProtocol','data-p','vri');
  $('bloodKet').style.display=''; $('urineKet').style.display='none'; $('bagSetup').style.display='';
  accState['acc-flow']=true; accState['acc-ins']=true;
  setTargetDefault();
  $('insProtocolNote').textContent=insProtoNotes.vri;
  updateLabels(); calc();
  ROOT.scrollIntoView({behavior:'smooth',block:'start'});
}

$('copyBtn').addEventListener('click',()=>copyAll($('copyBtn')));
$('printBtn').addEventListener('click',()=>window.print());
$('emailBtn').addEventListener('click',emailResults);
$('resetBtn').addEventListener('click',resetCalculator);
$('closeCopyModal').addEventListener('click',closeCopyModal);
$('copyModal').addEventListener('click',e=>{if(e.target===$('copyModal')) closeCopyModal();});
this.ownerDocument.addEventListener('keydown',e=>{
  if(!$('copyModal').classList.contains('show')) return;
  if(e.key==='Escape'){ closeCopyModal(); return; }
  if(e.key==='Tab'){
    const first=$('copyText'), last=$('closeCopyModal');
    if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
  }
});

calc();

    }
  }

  customElements.define(ELEMENT_NAME, DkaHhsCalculator);
})();
